import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

import * as S from '../common/styled';
import Icon from '../Icon';

export const IconStyledNotBookmarked = styled(Icon)`
  color: #fff;
  fill: none;
  border: #fff;
`;

export const IconStyledBookmarked = styled(Icon)`
  color: #fff;
`;

export const BookmarkButton = styled.button`
  ${S.BaseButton}
`;

export const BookmarkPopup = styled.div`
  position: absolute;
  right: 67px;
  top: -8px;
  padding: 8px 8px;
  background-color: #101010;
  color: #fff;
  font-size: 16px;
  width: max-content;

  a {
    color: white;
  }

  ${breakpoints.md} {
    right: 75px;
    top: -6px;
  }
`;
